type Key = string | number | symbol;

export const byKeyIncludes =
	<T extends { [x: Key]: any }>(key: keyof T, includesTerm: string) =>
	(value: T) =>
		includesTerm !== ''
			? value[key].toLowerCase().includes(includesTerm.toLowerCase())
			: true;
